import MessagePanelForm from "./message-panel-form";

export default MessagePanelForm;
